import React from "react";
import styled from "styled-components";

import Flex from "../../Flex";
import NavItems from "./NavItems/NavItems";
import NavbarSocial from "./NavItems/NavbarSocial";

const StyledHeader = styled.header`
    height: 100%;
    width: 100vw;
    background-color: var(--color-white);

    @media ${props => props.theme.mediaQueries.medium} {
        display: none;
    } 
`
const NavWrapper = styled(Flex)`
    margin: 0 auto;
    max-width: 1080px;
    height: 100px;
`
const Navbar = () => {
    return (
        <StyledHeader>
            <NavWrapper justifyContent="space-between" alignItems="center">
                <NavbarSocial />
                <NavItems />
            </NavWrapper>
        </StyledHeader>
    )
};

export default Navbar
